import { CefSharpPaymentRepository } from "Infrastructure/services/cefSharpService/local/CefSharpPaymentRepository";
import { IPinpadService } from "modules/payment/application/interfaces/IPinpadService";
import { TransactionType } from "modules/payment/domain/models/TransactionType";

export const UsePinpad = () => {

  const doPinpadPayment = async (value: number, type: TransactionType) => {
    const paymentService: IPinpadService = CefSharpPaymentRepository();
    const result = await paymentService.payAsync(value, type);
    return result
  };

  return {
    doPinpadPayment,
  };
};
